import { Modal, Stack, Text, Group, Button, Alert, List } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

interface Props {
  opened: boolean
  targetEmail: string
  isPending: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function AdminResetTotpModal({
  opened, targetEmail, isPending, onConfirm, onCancel,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={`Resetar TOTP de "${targetEmail}"?`}
      centered
      size="md"
    >
      <Stack>
        <Alert icon={<IconAlertTriangle size={18} />} color="yellow" variant="light">
          <Text size="sm" fw={600} mb={4}>Isso vai:</Text>
          <List size="sm" spacing={2}>
            <List.Item>Remover o segundo fator do Kanidm (irreversível)</List.Item>
            <List.Item>Encerrar todas as sessões ativas do usuário</List.Item>
            <List.Item>Notificar o usuário por email e WhatsApp</List.Item>
          </List>
        </Alert>

        <Text size="sm" c="dimmed">
          No próximo login, ele sera obrigado a configurar TOTP de novo no
          wizard <code>/auth/setup</code>.
        </Text>

        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onCancel} disabled={isPending}>
            Cancelar
          </Button>
          <Button color="red" loading={isPending} onClick={onConfirm}>
            Confirmar reset
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
